import { MOBILE_SCREEN_BREAKPOINT } from '../constants/device-breakpoints.contants';

export const isDesktopDevice = (width: number) => {
  return width > MOBILE_SCREEN_BREAKPOINT;
};
